import { fetchBasicUrlPostJson, fetchBasicJsonPost } from '@/script/common';

export default {
    getData: (page, itemsPerPage, filter, signal) => {
        let parameters = {
            page: page,
            pageSize: itemsPerPage,
            ...filter
        };
        return fetchBasicUrlPostJson('/Patient/GetPatientHistories', {
            asGridData: true,
            data: parameters,
            signal
        });
    },
};
